<template functional>
  <fieldset class="select-box-container">
    <label v-if="props.label" class="label">{{ props.label }}</label>
    <select
      class="select"
      :aria-label="props.label"
      :disabled="props.isDisabled"
      v-on="listeners.change ? { change: listeners.change } : null"
    >
      <template v-if="props.placeholderText">
        <option disabled selected hidden>{{ props.placeholderText }}</option>
      </template>
      <option
        v-for="option in props.options"
        :key="option.value"
        :value="option.value"
        :selected="option.isSelected"
      >
        {{ option.label }}
      </option>
    </select>
  </fieldset>
</template>

<script>
export default {
  name: 'SelectBox',
  props: {
    /**
     * Label for the textbox
     *
     * @type {string}
     */
    label: {
      type: String,
      default: ''
    },
    /**
     * Options for selectbox contains list of objects with properties: value, label, isSelected
     *
     * @type {Array}
     */
    options: {
      require: true,
      type: Array,
      default: () => []
    },
    /**
     * Flag property to disable the selectbox when needed
     *
     * @type {boolean}
     */
    isDisabled: {
      type: Boolean,
      default: false
    },
    /**
     * Placeholder text. If is not empty string, will have placeholder
     *
     * @type {string}
     */
    placeholderText: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ {
  .label {
    font-weight: bold;
    margin-right: 10px;
  }

  .select {
    height: 40px;
    appearance: none;
    border: 1px solid $grey-dark;
    text-overflow: ellipsis;
    outline: 0;
    border-radius: 0;
    padding-left: 15px;
    padding-right: 35px;

    background: transparent url('assets/fill-arrow.svg') no-repeat;
    background-position-x: calc(100% - 5px);
    background-position-y: center;
    background-size: 10px 10px;

    &[disabled] {
      background-color: $grey-light;
      cursor: not-allowed;
    }
  }
}
</style>
